import { createSelector } from '@reduxjs/toolkit';
import { type RootState } from 'services/redux/configureStore';

const selectSettings = (state: RootState) => state.video.settings;

// Этот селектор получает только те зависимости config плеера, которые должны полностью пересоздавать плеер
export const selectPlayerHardReloadDeps = createSelector([selectSettings], (s) => ({
  autoplay: s.player.autoplay,
  blockForwardSeek: s.player.blockForwardSeek,

  preview: s.preview,

  ctaBtn: s.cta.addCtaBtn
    ? {
        time: s.cta.time,
      }
    : null,
  playback: s.playback.addPlayback
    ? {
        showWhenPaused: s.playback.showWhenPaused,
        showWhenNotFullscreen: s.playback.showWhenNotFullscreen,
      }
    : null,
}));
